import { _ as _isKeyable } from "./auth-service-tools1345.js";
var isKeyable = _isKeyable;

function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}

var _getMapData = getMapData;
export { _getMapData as _ };